import React from 'react';
import { useDrive } from '../../contexts/DriveProvider';

const Toaster = () => {
  const { toasts } = useDrive();
  return (
    <div aria-live="polite" className="pointer-events-none fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 flex-col items-center gap-2">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`pointer-events-auto rounded-xl px-4 py-3 text-sm font-medium shadow-xl animate-in fade-in-0 slide-in-from-bottom-2 ${
            t.tone === 'error' ? 'bg-destructive text-destructive-foreground' : 'bg-ink text-ink-foreground'
          }`}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
};

export default Toaster;
